import React from 'react';
import {connect} from "react-redux";
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import TitleMedium from '../../shared/utils/TitleMedium';
import AuthService from "../../../services/AuthService";
import {getInfosSalarie} from "../../../actions/salarie/actions_salarie_1";
import CustomPaper from "../../shared/utils/CustomPaper";

class ProjetProSalarie extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            projet: ""
        };
        this.Auth = new AuthService();
        this.saveProjetPro = this.saveProjetPro.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return {projet: nextProps.infos.projet || ''};
    }

    saveProjetPro() {
        this.Auth.fetch('/salarie/projet_pro_exprime', {
            method: 'POST',
            data: this.state
        }).then(x => {
            this.props.dispatch(getInfosSalarie());
            alert('Enregistrement avec succès.');
        });
    }

    render() {
        return (
            <CustomPaper title='Projet professionnel'>
                <div style={{padding: 20}} className={'row'}>
                    <div className={'col'}>
                        <TitleMedium title={'Votre Projet Professionnel'}/>
                        <div className={'alert alert-info'}> Veuillez décrire ci-dessous votre projet professionnel sur
                            le
                            court et le long terme en indiquant des échéances, Exemples:<br/>
                            <ul>
                                <li>Je voudrais devenir chef de projet courant l'année 2019.</li>
                                <li>Je vise le poste de responsable d'agence sur le court terme.</li>
                            </ul>
                        </div>
                        <TextField
                            value={this.state.projet}
                            onChange={(x, y) => this.setState({projet: y})}
                            fullWidth={true}
                            name='projet'
                            type="text"
                            floatingLabelText="Projet envisagé"
                            multiLine={true}
                        /><br/>
                        <RaisedButton
                            primary={true}
                            onClick={() => this.saveProjetPro()}
                            label={'Mettre à jour votre projet'}
                        />
                    </div>
                </div>
            </CustomPaper>
        );
    }
}

function mapStateToProps(store) {
    return {infos: store.salarie.infos}
}

export default connect(mapStateToProps)(ProjetProSalarie);


// WEBPACK FOOTER //
// ./src/components/salarie/bodies/ProjetProSalarie.js